import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Divider, Modal, CardContent, Table, TableBody, TableCell, TableContainer, TableRow, TableHead } from '@mui/material';
import MainCard from 'components/MainCard';
import { useEffect } from 'react';
// import useModals from 'components/modals/useModal';
// import { modals } from 'components/modals/Modals'; 
import { useEnumApi } from 'contexts/EnumApiContext';
import { getMaintenanceEquipmentZonesByCompanyId } from 'components/axios/equipmentZoneAxios';

export function ManagementCompanyZoneSettingLayer({companyId, userId, checkZones, setUserZones}) {
  const { getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();

  // modal 관련
  // const { openModal } = useModals();
  // const handleAlertClick = (alertMessage) => {
  //     openModal(modals.alertModal, {
  //         onClose : () => {
  //             // console.log(1111);
  //         },
  //         message: alertMessage,
  //     });
  // };
  
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [zoneList, setZoneList] = useState([]);
  const [zones, setZones] = useState([]);

  useEffect(()=>{
    if (open) {
      getZoneList();
    }
  },[open]);

  const getZoneList = async() => {
    getMaintenanceEquipmentZonesByCompanyId(companyId).then((res) => {
      // console.log(res)
      // console.log(checkZones)
      // const checkZoneList = checkZones.filter((m)=>m.zone.id == )
      const zoneList = [];
      res.map((c)=>{
        c.equipmentZones.map((z)=>{
          // zoneList.push({id:z.id, name:z.name, address:z.address, info : c.info})
          // zoneList.push({...c , zid:z.id, checked: checkZones.some((m)=> `m.userId${userId}` === z.id)})
          // console.log(Object.values(checkZones).flat().includes(z.id))
          zoneList.push({...c , zid:z.id, checked: Object.values(checkZones).flat().includes(z.id)})
        })
      })
      setZoneList(zoneList)
      setZones(res)
    })
  }
  
  // 전체 선택 여부
  const allChecked = zoneList.every(a => a.checked);
  const someChecked = zoneList.some(a => a.checked);

  // 개별 체크
  const toggleCheck = (id) => {
    setZoneList(zoneList.map(a =>
      a.zid === id ? { ...a, checked: !a.checked } : a
    ));
  };

  // 전체 선택/해제
  const toggleAll = () => {
    // console.log(allChecked)
    // console.log(someChecked)
    const next = !allChecked;
    setZoneList(zoneList.map(a => ({ ...a, checked: next })));
  };

  const setting = () => {
    setUserZones(userId, zoneList.filter((z)=>z.checked).map((z2)=>z2.zid))
    handleClose();
  }

    return (
    <>
      <Button variant="outlined" style={{padding:"2px 5px"}} color="primary" onClick={handleOpen} >{t('message.common.btn.setting')}</Button>

      <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <MainCard title={t('message.common.subtitle.zone')} modal darkTitle content={false}>
          <div style={{marginTop:"-40px", marginRight:"12px", textAlign:"right"}}>
            <Button variant="contained" color="primary" size="small" onClick={handleClose}>
              {t('message.common.btn.close')}
            </Button>
          </div>
          <CardContent>

          <TableContainer>
            <Table sx={{ minWidth: 500 }} aria-label="simple table" className="list_table pop_table">
                <TableHead>
                  <TableRow>
                    <TableCell className="th" align="center">
                      <input
                        type="checkbox"
                        checked={allChecked}
                        ref={(input) => {
                          if (input) input.indeterminate = !allChecked && someChecked;
                        }}
                        onChange={toggleAll}
                      />
                    </TableCell>
                    <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.zone')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {zones && zones.map(function(company, i) {
                    const rowspan = company.equipmentZones.length;
                    return company.equipmentZones.map((zone, j) => {
                    return (
                  <React.Fragment key={`${i}-${j}`}>
                    <TableRow>
                      <TableCell>
                        <input
                          type="checkbox"
                          checked={zoneList.filter((z)=>z.zid===zone.id)[0]?.checked}
                          onChange={() => toggleCheck(zone.id)}
                        />
                      </TableCell>
                      {j === 0 && (
                      <TableCell rowSpan={rowspan}>{company.info.name}</TableCell>
                      )}
                      <TableCell>{zone.name}</TableCell>
                    </TableRow> 
                  </React.Fragment>
                    )
                    })
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <div className='btn_right'>
              <Button variant="contained" color="info" className="small_btn" onClick={()=>{setting()}}>
                {t('message.common.btn.setting')}
              </Button>
            </div>

          </CardContent>
          <Divider />

        </MainCard>
      </Modal>
    </>
    )
}

export default ManagementCompanyZoneSettingLayer;
